import script from "./order-inovice-apply.vue?vue&type=script&lang=ts&setup=true"
export * from "./order-inovice-apply.vue?vue&type=script&lang=ts&setup=true"

import "./order-inovice-apply.vue?vue&type=style&index=0&id=035bb0de&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-035bb0de"]])

export default __exports__